/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
import 'slick-carousel/slick/slick.js';
import 'chosen-js/chosen.jquery.js';
import bsBreakpoints from'bs-breakpoints';


// ===== CustomEvent Polyfill for IE =====
(function () {

  if ( typeof window.CustomEvent === 'function' ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  window.CustomEvent = CustomEvent;
})();

// Debounce function https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function setCookie(cname, cvalue, exhours) {
  var d = new Date();
  d.setTime(d.getTime() + (exhours*60*60*1000));
  var expires = 'expires='+ d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

var getCookie = function(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return '';
};

export default {
  init() {
    // JavaScript to be fired on all pages
    var breakpoint;
    var $header = $('header.banner');

    // === Update breakpoints and clear styles
    bsBreakpoints.init();
    breakpoint = bsBreakpoints.detectBreakpoint();
    console.log( $.inArray(breakpoint, ['small', 'xSmall']) );
    $(window).on('resize', function(){
      breakpoint = bsBreakpoints.detectBreakpoint();
      console.log( breakpoint );
    });

    /**
     * Define: Get URL variable
    */
    function getQueryVariable(variable)
    {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split('=');
              if(pair[0] == variable){return pair[1];}
      }
      return(false);
    }

    /**
    * Define: smooth scroll
    */
    function smoothScroll(_this, time = 1000) {
      if( !_this ) return false;
      var marginT = _this.css('marginTop') || 0,
          adminbarH = $('#wpadminbar').height() || 0,
          _thisOffset = _this.offset() ? _this.offset().top : 0,
          targetOffset = _thisOffset - parseInt(marginT) - adminbarH;
      $('html,body').animate({scrollTop: targetOffset}, time);
    }

    /**
    * Attach smooth scroll to elements
    */
    $('.btn[href^="#"]').on('click', function(e){
      e.preventDefault();
      var el = $( this.getAttribute('href') );
      if( el.length ) smoothScroll(el);
    })

    // ===== Main navigation actions =====
    var navToggle = $('.nav-menu-toggle');
    if( navToggle.length ) {

      // --- Toggle sub menu
      navToggle.on('click', function(e){
        var _this = $(this),
            menu = _this.next('.sub-menu');

        e.stopPropagation();

        // --- toggle current item class
        if( menu.length ) {
          // console.log(_this);
          // console.log( _this.parent().parent() );
          // --- If top level item then hide other dropdowns
          if( $.inArray(breakpoint, ['small', 'xSmall']) == -1 && _this.parent().parent().hasClass('navbar-nav') && !_this.hasClass('open') ) {
            $('.navbar-nav > li > .nav-menu-toggle.open').removeClass('open').next().hide();
            console.log('close all open nav toggles');
          }
          _this.toggleClass('open');
          if( _this.hasClass('open') ) {
            console.log('menu was closed');
            menu.slideDown();
          }else {
            console.log('menu was open');
            menu.slideUp();
          }
        }
      });

      // === Main header: hide on scroll
      var startingPoint = window.pageYOffset;
      var headerScroll = debounce(function() {
        var currentPoint = window.scrollY;

        if (currentPoint > startingPoint) {
          $header.addClass('slide-up');
          console.log(currentPoint + '>' + startingPoint);
        }
        if (currentPoint < startingPoint) {
          $header.removeClass('slide-up');
          // console.log(currentPoint + '<' + startingPoint);
        }
        startingPoint = currentPoint;
      }, 100);
      document.addEventListener('touchmove', headerScroll);
      document.addEventListener('scroll', headerScroll);

    }

    // === Main header: change bg when scrolling page
    if( $header.length ) {
      console.log('Found: Main header');
      var headerH = $header.height();
      $(window).on('scroll', function(event){
        var st = $(this).scrollTop();
        if (st > headerH){
          // downscroll code
          $header.addClass('solid');
        } else {
          // upscroll code
          $header.removeClass('solid');
        }
      });
    }

    // ===== Hero Panel actions
    // === Has Video
    var videos = $('.panel-hero .hero-video video, .block-video video');
    if( videos.length ) {
      console.log('Found: Video panels - ' + videos.length);
      // videos.on('click', function(){
      //   var _this = $(this).get(0);
      //   console.log( _this.paused );
      //   if( _this.paused ) {
      //     _this.play();
      //   }else {
      //     _this.pause();
      //   }
      // });
    }

    // ===== Initialize all Slick carousels =====
    // === footer carousel
    var footerCarousel = $('.content-info .carousel');
    if (footerCarousel.length) {

      console.log('Found: Footer Carousel');

      footerCarousel.on( 'touchend touchcancel touchmove', function() {
        $(this).slick('slickPlay');
      });

      footerCarousel.each(function(){
        var $this = $(this);
        $this.slick({
          autoplay: true,
          infinite: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: false,
          dots: false,
          draggable: true,
          edgeFriction: 0.15,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 800,
          autoplaySpeed: 5000,
          adaptiveHeight: false,
          fade: true,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                fade: false,
              },
            },
          ],
          cssEase: 'ease',
        });
      });

    }

    // === Block: Image carousel
    var featuredCarousel = $('.block-carousel .carousel');
    if (featuredCarousel.length) {

      console.log('Found: Image Carousels');

      featuredCarousel.on( 'touchend touchcancel touchmove', function() {
        $(this).slick('slickPlay');
      }).on('afterChange', function(event, slick, currentSlide){
        // console.log('afterchange');
        let $slider = $(slick.$slider);
        let captionText = $('.caption__text', $slider.parent());
        let captionCount = $('.caption__count', $slider.parent());
        var currentCaption = $(slick.$slides[currentSlide]).find('img').attr('data-caption');
        let totalSlides = slick.slideCount;
        let currentSlideNumber = currentSlide + 1;
        if(captionText.length) captionText.text( currentCaption );
        if(captionCount.length) captionCount.text( currentSlideNumber + ' / ' + totalSlides );
      });

      featuredCarousel.each(function(){
        var $this = $(this);
        var showAllSlides = $this.parent().hasClass('show-all-slides');
        $this.slick({
          autoplay: true,
          infinite: false,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: showAllSlides ? true : false,
          dots: true,
          draggable: true,
          edgeFriction: 0.15,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 800,
          autoplaySpeed: 5000,
          adaptiveHeight: false,
          fade: false,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: showAllSlides ? 999 : 1,
              },
            },
          ],
          cssEase: 'ease',
          appendDots: $('.caption', $this.parent()),
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><svg viewBox="0 0 15 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M0.292893 6.65691C-0.0976315 7.04743 -0.0976315 7.6806 0.292893 8.07112L6.65685 14.4351C7.04738 14.8256 7.68054 14.8256 8.07107 14.4351C8.46159 14.0446 8.46159 13.4114 8.07107 13.0209L2.41421 7.36401L8.07107 1.70716C8.46159 1.31664 8.46159 0.68347 8.07107 0.292946C7.68054 -0.0975785 7.04738 -0.0975785 6.65685 0.292946L0.292893 6.65691ZM15 7.36401V6.36401L1 6.36401V7.36401V8.36401L15 8.36401V7.36401Z"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><svg viewBox="0 0 15 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M14.7071 8.07112C15.0976 7.6806 15.0976 7.04743 14.7071 6.65691L8.34315 0.292947C7.95262 -0.0975778 7.31946 -0.0975779 6.92893 0.292946C6.53841 0.683471 6.53841 1.31664 6.92893 1.70716L12.5858 7.36401L6.92893 13.0209C6.53841 13.4114 6.53841 14.0446 6.92893 14.4351C7.31946 14.8256 7.95262 14.8256 8.34314 14.4351L14.7071 8.07112ZM0 7.36401L-8.74228e-08 8.36401L14 8.36401L14 7.36401L14 6.36401L8.74228e-08 6.36401L0 7.36401Z" /></svg></button>',
          lazyLoad: 'ondemand', // Set lazy loading technique. Accepts 'ondemand' or 'progressive',
          // customPaging : function(slider, i) {
          //   // var thumb = $(slider.$slides[i]).data();
          //   var id = i+1;
          //   return '<button class="dot">'+id+'</button>';
          // },
        });
      });

    }

    // === Hero Panel: Carousel
    var heroCarousel = $('.panel-hero.has-carousel .carousel');
    if (heroCarousel.length) {

      console.log('Found: Featured Carousels');

      heroCarousel.on( 'touchend touchcancel touchmove', function() {
        $(this).slick('slickPlay');
      }).on('afterChange', function(event, slick, currentSlide){
        // console.log('afterchange');
        let $slider = $(slick.$slider);
        let captionText = $('.caption__text', $slider.parent());
        let captionCount = $('.caption__count', $slider.parent());
        var currentCaption = $(slick.$slides[currentSlide]).find('img').attr('data-caption');
        let totalSlides = slick.slideCount;
        let currentSlideNumber = currentSlide + 1;
        if(captionText.length) captionText.text( currentCaption );
        if(captionCount.length) captionCount.text( currentSlideNumber + ' / ' + totalSlides );
      });

      heroCarousel.on('lazyLoaded', function(){
        // alert('carousel images loaded');
      })

      heroCarousel.each(function(){
        var $this = $(this);
        $this.slick({
          autoplay: true,
          infinite: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: false,
          dots: true,
          draggable: true,
          edgeFriction: 0.15,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 800,
          autoplaySpeed: 5000,
          adaptiveHeight: false,
          fade: true,
          cssEase: 'ease',
          appendDots: $('.caption', $this.parent()),
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><svg viewBox="0 0 25 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM25 3.5L1 3.5V4.5L25 4.5V3.5Z"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><svg viewBox="0 0 25 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0L0 4.5Z"/></svg></button>',
          lazyLoad: 'progressive', // Set lazy loading technique. Accepts 'ondemand' or 'progressive',
        });
      });
    }

    // ===== Promo popup actions =====
    var promoPopup = $('#js-promo-popup'),
        promoPopupTarget,
        promoPopupLink;
    if( promoPopup.length ) {
      var promoCta = $('.promo-buttons .btn, .promo-popup-image > a', promoPopup),
        cookie_name = promoPopup.data('cookiename'),
        cookie_timeout = promoPopup.data('timeout');

      promoPopup.on('hide.bs.modal', function (e) {
        console.log('popup is hiding');
        // --- set timeout cookie if applicable
        if( !getCookie(cookie_name) && cookie_timeout ) setCookie(cookie_name,1,cookie_timeout);
      });

      promoPopup.on('hidden.bs.modal', function (e) {
        // console.log(promoPopupTarget, typeof promoPopupTarget);
        if( promoPopupLink ) {
          if(promoPopupTarget && promoPopupTarget.indexOf('_blank') !== -1 ) {
            console.log('open in new tab');
            window.open(promoPopupLink, '_blank'); // Open link in new tab
          }else {
            console.log('open in same tab');
            location.href = promoPopupLink;
          }
        }
        console.log('popup is hidden');
      });

      promoCta.on('click', function(e){
        var href = $(this).attr('href'),
            target = $(this).attr('target');
        e.preventDefault();
        // console.log('promo CTA clicked', href, target);
        promoPopupLink = href;
        promoPopupTarget = target;
        promoPopup.modal('hide');
      });

      promoPopup.modal('show');
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    var selectElements = $('.wrap select');
    if( !$('body').hasClass('no-chosen') && selectElements.length ) {
      console.log('select elements found');
      selectElements.chosen({disable_search_threshold: 999});
    }

    // ===== Booking widget =====
    var bilberryAttempts = 0;
    var bilberryInterval = setInterval(function() {
      bilberryAttempts++;

      const host = document.querySelector('bilberry-request-tour');
      const root = host ? host.shadowRoot : false;

      if (!root) {
        if (bilberryAttempts >= 100) {
          clearInterval(bilberryInterval);
          console.warn('Bilberry widget root not available.');
        }
        return;
      }

      clearInterval(bilberryInterval);
      console.log('we have root element ready...');

      // --- custom widget styling ---
      if (!root.querySelector('[data-bilberry-injected-style="1"]')) {
        const style = document.createElement('style');
        style.setAttribute('data-bilberry-injected-style', '1');
        style.textContent = `
          .bilberry-widget-root > .MuiGrid-root[aria-expanded="false"] {
            max-width: 200px;
          }
        `;
        root.appendChild(style);
      }

      // --- Fake "request booking" Button action
      var bookingBtns = $('[href="#booking-widget"]');
      if (bookingBtns.length) {
        // --- booking btns---
        bookingBtns.off('click.bilberry').on('click.bilberry', function(){
          console.log('booking widget btn clicked...');

          // Works only when shadow root is open
          const currentRoot = host.shadowRoot;
          if (!currentRoot) {
            console.warn('Bilberry widget internals are not accessible (closed shadow root or iframe).');
            return;
          }

          const openBtn = currentRoot.querySelector(
            'button[aria-label="Open request tour window"], button[aria-label="Close request tour window"]'
          );
          if (openBtn) openBtn.click();
        });
      }
    }, 300);

    // Inline booking widget
    var bilberryInlineAttempts = 0;
    var bilberryInlineInterval = setInterval(function() {
      bilberryInlineAttempts++;

      const hosts = document.querySelectorAll('bilberry-booking-inline');
      var pendingRoots = 0;

      if (!hosts.length) {
        if (bilberryInlineAttempts >= 100) {
          clearInterval(bilberryInlineInterval);
          console.warn('Bilberry inline widgets not found.');
        }
        return;
      }

      hosts.forEach(function(host) {
        const root = host.shadowRoot;

        if (!root) {
          pendingRoots++;
          return;
        }

        // --- custom widget styling ---
        if (!root.querySelector('[data-bilberry-injected-style="1"]')) {
          console.log('injecting inline widget styles...');
          const style = document.createElement('style');
          style.setAttribute('data-bilberry-injected-style', '1');
          style.textContent = `
            .bilberry-widget-root > .MuiGrid-root > .MuiPaper-root {
              max-width: 100%;
              box-shadow: none;
            }
          `;
          root.appendChild(style);
        }
      });

      if (pendingRoots === 0) {
        clearInterval(bilberryInlineInterval);
        console.log('all inline widget root elements ready...');
      } else if (bilberryInlineAttempts >= 100) {
        clearInterval(bilberryInlineInterval);
        console.warn('Bilberry inline widget roots not available for all instances.');
      }
    }, 300);

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js